import React, { useState, useRef, useEffect, useContext } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Loaders from '@/product/components/molecules/Loaders'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import {
    Button,
    Dialog,
    DialogContent,
    FormControl,
    MenuItem,
    Select,
    Tooltip,
} from '@mui/material'
import './member.css'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@emotion/react'
import { mapData } from '@/product/common/components'
import BarCodeScan from './barcode'
import SettingContext from '@/product/context/setting/settingContext'
import ReturnContext from '@/custom/context/return/returnContext'
import AlertContext from '@/product/context/alert/alertContext'
import {
    capitalize,
    currencyFormat,
    dateTimeFormatFunction,
    isValidHttpUrl,
} from '@/custom/common/components'
import RefundContext from '@/product/context/return/returnContext'
import AuthContext from '@/product/context/auth/authContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomTextArea from '@/product/components/atoms/Inputs/CustomTextArea'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { editValue } from '@/product/components/species/dynamic/common/FieldFunction'
import ProductContext from '@/product/context/product/productContext'
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core'
import {
    SortableContext,
    useSortable,
    arrayMove,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import ImageZoom from '@/custom/components/organisms/ImageZoom'
import dayjs from 'dayjs'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'

const StepTwo = (props) => {
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const returncontext = useContext(ReturnContext)
    const {
        single_request,
        getSingleRequest,
        clearResponse: clearResponseRequest,
    } = returncontext
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const dynamicContext = useContext(DynamicContext)
    const { project_dynamicfields } = dynamicContext

    const productContext = useContext(ProductContext)
    const { changeProductStatus, responseStatus: responseStatusProduct } =
        productContext
    const isMobile = window.innerWidth <= 768
    const from = `relist`
    const [isLoading, setIsLoading] = useState(true)
    const [itemsRecords, setItemsRecords] = useState([])
    const [trnsactions, setTransactions] = useState([])
    const [returnTransactions, setReturnTransactions] = useState([])
    const [inputFocus, setInputFocus] = useState(false)
    const [imagesOrder, setImagesOrder] = useState([])
    const [scanToggle, setScanToggle] = useState(false)
    const [scanType, setScanType] = useState('user')
    const [images, setImages] = useState([])
    const [imageIndex, setImageIndex] = useState(0)
    const [imageZoomModal, setImageZoomModal] = useState(false)
    const [checkedImages, setCheckedImages] = useState(new Set())
    const [addPhotos, setAddPhotos] = useState(false)
    const [fileUploaded, setFileUploaded] = useState('')
    const [isEditable, setIsEditable] = useState(false)
    const [initialValues, setInitialValues] = useState({
        relist_type: 'relist',
    })
    const [bulkOpen, setBulkOpen] = useState(false)
    const [discardOpen, setDiscardOpen] = useState(false)
    const [relistOpen, setRelistOpen] = useState(false)

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                delay: 100,
                tolerance: 5,
            },
        })
    )
    const [openToolTip, setOpenToolTip] = useState(false)
    function handleToolOpen() {
        setOpenToolTip((prev) => !prev)
    }
    const getDateClosed = () => {
        const endDate = dayjs(formik.values.end_date).format('YYYY-MM-DD')
        const endTime = dayjs(formik.values.end_time, 'hh:mm:ss a').format(
            'HH:mm:ss'
        )

        let date_closed = dayjs(`${endDate}T${endTime}`).format(
            'YYYY-MM-DDTHH:mm:ssZ'
        )
        date_closed = dayjs(date_closed).isValid() ? date_closed : null
        formik.setFieldValue('date_closed', date_closed)
        return date_closed
    }

    const validationArray = Yup.object().shape({
        relist_type: Yup.string().required('Relist type is required'),
        title: Yup.string().when('relist_type', {
            is: 'relist',
            then: Yup.string().required('Title is a required field'),
            otherwise: Yup.string().notRequired(),
        }),
        item_id: Yup.string().when('relist_type', {
            is: 'relist',
            then: Yup.string().required('Please enter a valid Item ID'),
            otherwise: Yup.string().notRequired(),
        }),
        desc_proc: Yup.string().when('relist_type', {
            is: 'relist',
            then: Yup.string().required('Please enter a valid Description'),
            otherwise: Yup.string().notRequired(),
        }),
        bin_location: Yup.string().when(['relist_type'], {
            is: (relist_type) =>
                relist_type === 'relist' || relist_type === 'bulk',
            then: Yup.string().required(
                'Please enter a valid location in facility'
            ),
            otherwise: Yup.string().notRequired(),
        }),
        disclaimer: Yup.string().when('relist_type', {
            is: 'relist',
            then: Yup.string().notRequired(),
            otherwise: Yup.string().notRequired(),
        }),
    })

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.status === 'success') {
                if (
                    responseStatusProduct?.from === 'relist' ||
                    responseStatusProduct?.from === from
                ) {
                    handleClose()
                }
            }
        }
        setIsLoading(false)
    }, [responseStatusProduct])

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            let payload = {
                id: values?.id || allRecords?.project_id || 0,
                customMessage: 'Successfully Updated',
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                action: 'relist',
            }

            if (values?.relist_type === 'bulk') {
                payload.bin_location = values.bin_location
                payload.relist_type = values?.relist_type
            }

            if (values?.relist_type === 'relist') {
                const date_closed = getDateClosed()

                const uploadImages = [
                    values.selectedImages.toString(),
                    fileFormik.values.file_path?.toString(),
                ]
                    .filter(Boolean)
                    .map((imageUrl) => imageUrl.trim())
                    .join(',')

                payload = {
                    ...payload,
                    ...values,
                    date_closed: date_closed,
                    uploadimages: uploadImages,
                }
            }

            console.log(`payload changeProductStatus `, payload, values)
            changeProductStatus(payload, `relist`, true)
        },
    })

    useEffect(() => {
        if (single_request && single_request.records.records.length) {
            let allRecords = single_request.records.records.length
                ? single_request.records.records[0]
                : []

            let projectDynamicArray = [...project_dynamicfields]
            projectDynamicArray = projectDynamicArray.filter(
                (data) => data.active === 1
            )

            projectDynamicArray.push(
                {
                    name: 'avatar',
                    value: allRecords?.avatar,
                    type: 'text',
                    active: 1,
                },
                {
                    name: 'end_date',
                    value: allRecords?.end_date,
                    type: '',
                    active: 1,
                },
                {
                    name: 'end_time',
                    value: allRecords?.end_time,
                    type: '',
                    active: 1,
                },
                {
                    name: 'comment',
                    value: '',
                    type: 'text',
                    active: 1,
                },
                {
                    name: 'duplicate_count',
                    value: allRecords?.duplicate_count,
                    type: 'number',
                    active: 1,
                },
                {
                    name: 'created_at',
                    value: allRecords?.created_at,
                    type: 'datetime',
                    active: 1,
                },
                {
                    name: 'keywords',
                    value: allRecords?.keywords,
                    type: 'text',
                    active: 1,
                },
                {
                    name: 'sub_category',
                    value: allRecords?.sub_category,
                    type: 'number',
                    active: 1,
                }
            )

            let objectPush = editValue(projectDynamicArray, allRecords)

            setInitialValues({
                ...objectPush,
                bprice: allRecords?.bprice || null,
                duplicateLotCount: 1,
                keywords: objectPush.keywords?.length
                    ? String(objectPush.keywords).split(',')
                    : [],
                id: allRecords?.project_id || 0,
                relist_type: 'relist',
            })

            formik.setValues({
                ...objectPush,
                bprice: allRecords?.bprice || null,
                duplicateLotCount: 1,
                keywords: objectPush.keywords?.length
                    ? String(objectPush.keywords).split(',')
                    : [],
                id: allRecords?.project_id || 0,
                relist_type: 'relist',
            })

            if (allRecords.uploadimages) {
                allRecords.uploadimages = allRecords.uploadimages
                    .toString()
                    .split(',')
            }
            setItemsRecords(allRecords)
            setTransactions(single_request.records.allTransactions)
            setReturnTransactions(
                single_request.records?.returnTransactions?.length
                    ? single_request.records?.returnTransactions
                    : []
            )

            if (
                !objectPush?.item_id ||
                objectPush.item_id === '' ||
                objectPush.item_id === null ||
                objectPush.item_id === undefined
            ) {
                setIsEditable(true)
            } else {
                setIsEditable(false)
            }

            setTimeout(() => {
                setIsLoading(false)
            }, 500)
        }
    }, [single_request])

    useEffect(() => {
        clearAll()
        if (props.pid || props?.bid) {
            formik.values.project_id = props.pid
            formik.values.bid = props.bid
            getSingleRequest({
                project_id: props.pid,
                bid: props.bid,
                common_invoice: props.cid,
            })
        }
    }, [props.open])

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        // validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const changeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const setDecodedBarcode = (data) => {
        console.log('i am scanned here ', scanType, data)
        if (data && data !== '') {
            formik.values.bin_location = data
        }
    }

    const handleScanInput = (type) => {
        if (type === 'product') {
            setScanType('product')
        } else {
            setScanType('user')
        }
        setScanToggle(true)
    }

    useEffect(() => {
        if (itemsRecords?.uploadimages) {
            // const avatar = itemsRecords?.avatar ?? null
            const uploadImages = itemsRecords?.uploadimages
                ? String(itemsRecords.uploadimages).split(',').filter(Boolean)
                : []

            const customerImages = itemsRecords?.return_images
                ? String(itemsRecords.return_images).split(',').filter(Boolean)
                : []
            const adminImages = itemsRecords?.admin_images
                ? String(itemsRecords.admin_images).split(',').filter(Boolean)
                : []

            const allImages = [
                // ...(avatar ? [avatar] : []),
                ...uploadImages,
                ...customerImages,
                ...adminImages,
            ]
            setImagesOrder(allImages)

            setImages(
                allImages.map((image) => ({
                    main: isValidHttpUrl(image)
                        ? image
                        : global.images_url + image,
                }))
            )

            const defaultChecked = new Set([
                // ...(avatar ? [avatar] : []),
                ...uploadImages,
            ])
            setCheckedImages(defaultChecked)
        }
    }, [itemsRecords?.uploadimages])

    const statusOptions = [
        { show: 'Relist', value: 'relist' },
        { show: 'Bulk', value: 'bulk' },
        { show: 'Discard/Recycle', value: 'discard' },
    ]

    const onDragEnd = (event) => {
        const { active, over } = event

        if (over && active.id !== over.id) {
            const from = imagesOrder.findIndex((file) => file === active.id)
            const to = imagesOrder.findIndex((file) => file === over.id)

            if (from !== -1 && to !== -1) {
                const reorderedItems = arrayMove(imagesOrder, from, to)
                setImagesOrder(reorderedItems)
                setImages(
                    reorderedItems.map((image) => ({
                        main: isValidHttpUrl(image)
                            ? image
                            : global.images_url + image,
                    }))
                )
                setInputFocus(true)
                formik.setFieldValue('updateLotImages', true)
            }
        }
    }

    const SortableImage = ({
        id,
        file,
        index,
        className,
        checked,
        onCheckChange,
    }) => {
        const {
            attributes,
            listeners,
            setNodeRef,
            transform,
            transition,
            isDragging,
        } = useSortable({ id })

        const style = {
            transform: CSS.Transform.toString(transform),
            transition,
            opacity: isDragging ? 0.5 : 1,
            cursor: 'grab',
            zIndex: isDragging ? 1000 : 1,
            position: 'relative',
        }

        return (
            <div
                ref={setNodeRef}
                style={style}
                // {...attributes}
                // {...listeners}
                className={`thumb ${className}`}
            >
                <div className="thumbInner">
                    <div className="thumbCnt">
                        {/* Drag handle area - only the image part */}
                        <div
                            {...attributes}
                            {...listeners}
                            className="drag-handle"
                        >
                            <img
                                src={
                                    isValidHttpUrl(file)
                                        ? file
                                        : `${global.images_url}${file}`
                                }
                                className="img"
                                alt="File Thumbnail"
                                onClick={() => handleImageClick(index)}
                            />
                        </div>

                        {/* Checkbox with pointer-events protection */}
                        <div
                            className={`image-checkbox-container ${
                                checked ? 'checked' : ''
                            }`}
                            onClick={(e) => {
                                e.stopPropagation()

                                onCheckChange(!checked)
                            }}
                            style={{ pointerEvents: 'auto' }} // Force pointer events
                        >
                            <span className="material-icons checkmark">
                                check
                            </span>
                        </div>

                        {isDragging && (
                            <div className="dragIcon">
                                <span className="material-icons">
                                    open_with
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    const handleImageClick = (index) => {
        setImageIndex(index)
        setImageZoomModal(true)
    }

    const toggleImage = (direction) => {
        if (direction === 'next' && imageIndex < images.length - 1) {
            setImageIndex(imageIndex + 1)
        } else if (direction === 'prev' && imageIndex > 0) {
            setImageIndex(imageIndex - 1)
        }
    }

    const handleCheckChange = (file, isChecked) => {
        setCheckedImages((prev) => {
            const newSet = new Set(prev)
            isChecked ? newSet.add(file) : newSet.delete(file)
            return newSet
        })
    }

    useEffect(() => {
        const selectedImages = imagesOrder.filter((file) =>
            checkedImages.has(file)
        )
        formik.setFieldValue('selectedImages', selectedImages)
        formik.setFieldValue('updateLotImages', true)
    }, [imagesOrder, checkedImages, formik.setFieldValue])

    const handleRelistType = (value) => {
        setInputFocus(true)
        formik.setFieldValue(`relist_type`, value)
        if (value === 'bulk') {
            setBulkOpen(true)
        } else if (value === 'discard') {
            setDiscardOpen(true)
        } else if (value === 'relist') {
            setRelistOpen(true)
        } else {
            setBulkOpen(false)
            setDiscardOpen(false)
        }
    }

    const handleCloseRelist = (value) => {
        if (value === 'bulk') {
            setBulkOpen(false)
        } else if (value === 'discard') {
            setDiscardOpen(false)
        } else if (value === 'relist') {
            setRelistOpen(false)
        } else {
            setBulkOpen(false)
            setDiscardOpen(false)
        }
        formik.setFieldValue(`relist_type`, 'relist')
    }

    const handleUpload = (newData) => {
        setFileUploaded(newData)
    }

    const fileUpload = {
        formik: fileFormik,
        data: [
            {
                type: 'uploadDropZone',
                name: 'file_path',
                icon: 'description',
                titleText: 'Upload Lot Images',
                class: `col-12`,
                folder: 'product',
                multiple: true,
                disableEditing: true,
                getBlobUrl: handleUpload,
                webcam: false,
                accept: 'image/*',
                reorder: true,
                // showFileName: true,
            },
        ],
    }

    useEffect(() => {
        if (fileUploaded?.name) {
            setInputFocus(true)
            formik.setFieldValue('updateLotImages', true)
        }
    }, [fileUploaded])

    const handleClose = () => {
        clearAll()
        props.handleClose('relist')
    }

    const clearAll = () => {
        setIsLoading(true)
        setItemsRecords([])
        setTransactions([])
        setReturnTransactions([])
        setInputFocus(false)
        setImagesOrder([])
        setScanToggle(false)
        setScanType('user')
        setImages([])
        setImageIndex(0)
        setImageZoomModal(false)
        setCheckedImages(new Set())
        setAddPhotos(false)
        setFileUploaded('')
        setInitialValues({
            relist_type: 'relist',
        })
        setBulkOpen(false)
        setDiscardOpen(false)
        setRelistOpen(false)
    }

    const throwAlert = (message) =>
        setAlert(message || 'Please enter all required fields', 'error')

    const validateForm = async () => {
        const errors = await formik.validateForm()
        if (Object.keys(errors).length > 0) {
            throwAlert(Object.values(errors)[0])
            return false
        }
        return true
    }

    return (
        <FullScreenPopup
            modaltitle={'Return Approved'}
            open={props.open}
            handleClose={() => handleClose()}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <Loaders isLoading={isLoading} />
                    ) : (
                        <>
                            <div className="text-left returnInfoListGet mt-4 proEditView">
                                <h3>Edit Now</h3>
                                <div className="formFields w-75 w-sm-100 mt-2">
                                    <label>
                                        What would you like to do with the item?
                                    </label>
                                    <FormControl fullWidth>
                                        <Select
                                            id="status"
                                            labelId="status-label"
                                            value={formik.values.relist_type}
                                            onChange={(e) => {
                                                handleRelistType(e.target.value)
                                            }}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return 'Select a Type'
                                                }
                                                const selectedOption =
                                                    statusOptions?.find(
                                                        (opt) =>
                                                            opt.value ===
                                                            selected
                                                    )
                                                return selectedOption
                                                    ? selectedOption.show
                                                    : 'Select a Type'
                                            }}
                                            name="relist_type"
                                        >
                                            {statusOptions?.map((opt) => (
                                                <MenuItem
                                                    key={opt.value}
                                                    value={opt.value}
                                                >
                                                    {opt.show}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="formFields w-75 w-sm-100 mt-3">
                                    <label>Customer Reason :</label>
                                    <CustomInput
                                        type="text"
                                        placeholder="Select"
                                        value={itemsRecords?.return_reason}
                                        disabled={true}
                                    />
                                </div>
                                <div className="formFields w-75 w-sm-100">
                                    <label>Customer Comments :</label>
                                    <CustomTextArea
                                        disabled={true}
                                        type="text"
                                        placeholder="Enter Title"
                                        value={itemsRecords?.return_comments}
                                    />
                                </div>

                                {/* {trnsactions?.length ? (
                                    <div className="formFields">
                                        <div className="font-weight-bold">
                                            Item Refundable Amount: {'  '}
                                            {currencyFormat(
                                                itemsRecords?.buynow_total_amount ||
                                                    0
                                            )}
                                        </div>
                                        <div className="w-25 d-flex align-items-center justify-content-between gap-3 flex-nowrap my-3 font-weight-bold">
                                            <span>Payment Type</span>
                                            <span>Amount</span>
                                        </div>
                                        {trnsactions.map((item, index) => (
                                            <div
                                                key={index}
                                                className="w-25 d-flex align-items-center justify-content-between gap-3 flex-nowrap my-3"
                                            >
                                                {item.payment_method ===
                                                'Card' ? (
                                                    <>
                                                        <span>
                                                            CC{' '}
                                                            {
                                                                item.mk_card_number
                                                            }
                                                        </span>
                                                        <span>
                                                            {currencyFormat(
                                                                item.paid_amount
                                                            )}
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span>
                                                            {capitalize(
                                                                item?.payment_method ||
                                                                    'Unknown'
                                                            )}
                                                        </span>
                                                        <span>
                                                            {currencyFormat(
                                                                item.amount
                                                            )}
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ) : null} */}

                                {trnsactions?.length ? (
                                    <>
                                        <div
                                            style={{ width: '200px' }}
                                            className="font-weight-bold invoiceSubTitle"
                                        >
                                            Payment Transactions
                                        </div>
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <>
                                                <table className="table table-bordered table-responsive">
                                                    <thead>
                                                        <tr>
                                                            {/* <th scope="col">S.No</th> */}
                                                            <th scope="col">
                                                                {
                                                                    'Transaction id'
                                                                }
                                                            </th>
                                                            <th scope="col">
                                                                {'Paid on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Status'}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {trnsactions.map(
                                                            (data, index) => (
                                                                <>
                                                                    <tr
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        <td
                                                                            data-title={
                                                                                'Transaction id'
                                                                            }
                                                                        >
                                                                            {data.trans_id
                                                                                ? `# ${data.trans_id}`
                                                                                : '-'}
                                                                        </td>
                                                                        <td
                                                                            style={{
                                                                                minWidth:
                                                                                    '112px',
                                                                            }}
                                                                            data-title={
                                                                                'Paid on'
                                                                            }
                                                                        >
                                                                            {dateTimeFormatFunction(
                                                                                data.created_at
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            data-title={
                                                                                'Card'
                                                                            }
                                                                        >
                                                                            {data.payment_method ===
                                                                            'Card' ? (
                                                                                <>
                                                                                    {capitalize(
                                                                                        data.payment_method
                                                                                    )}{' '}
                                                                                    -{' '}
                                                                                    {
                                                                                        data.mk_card_number
                                                                                    }{' '}
                                                                                    (
                                                                                    {
                                                                                        data.card_type
                                                                                    }

                                                                                    )
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    {capitalize(
                                                                                        data.payment_method
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            data-title={
                                                                                'Amount'
                                                                            }
                                                                        >
                                                                            {currencyFormat(
                                                                                data.amount,
                                                                                2
                                                                            )}
                                                                        </td>
                                                                        <td
                                                                            data-title={
                                                                                'Payment status'
                                                                            }
                                                                            style={{
                                                                                color:
                                                                                    data.status ===
                                                                                    'success'
                                                                                        ? 'green'
                                                                                        : 'red',
                                                                            }}
                                                                        >
                                                                            {capitalize(
                                                                                data.status ===
                                                                                    'success'
                                                                                    ? 'Paid'
                                                                                    : 'UnPaid'
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        </div>
                                    </>
                                ) : null}

                                {returnTransactions?.length ? (
                                    <>
                                        <div
                                            style={{ width: '200px' }}
                                            className="font-weight-bold invoiceSubTitle"
                                        >
                                            Refund Transactions
                                        </div>
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <>
                                                <table className="table table-bordered table-responsive">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">
                                                                {'Refund id'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Refund on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {
                                                                    'Refund Status'
                                                                }
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {returnTransactions.map(
                                                            (data, index) => (
                                                                <tr key={index}>
                                                                    <td
                                                                        data-title={
                                                                            'Transaction id'
                                                                        }
                                                                    >
                                                                        {data.reftrans_id
                                                                            ? `# ${data.reftrans_id}`
                                                                            : 'Credit Refund'}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            minWidth:
                                                                                '112px',
                                                                        }}
                                                                        data-title={
                                                                            'Refund on'
                                                                        }
                                                                    >
                                                                        {dateTimeFormatFunction(
                                                                            data.created_at
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Amount'
                                                                        }
                                                                    >
                                                                        {currencyFormat(
                                                                            data.amount,
                                                                            2
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Method'
                                                                        }
                                                                    >
                                                                        {data?.refund_method ===
                                                                        'stripe'
                                                                            ? 'Card'
                                                                            : 'Wallet'}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Refund status'
                                                                        }
                                                                        style={{
                                                                            color:
                                                                                data.status ===
                                                                                'success'
                                                                                    ? 'green'
                                                                                    : 'red',
                                                                        }}
                                                                    >
                                                                        {capitalize(
                                                                            data.status ===
                                                                                'success'
                                                                                ? 'Success'
                                                                                : 'Failed'
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        </div>
                                    </>
                                ) : null}

                                {itemsRecords?.admin_id ? (
                                    // <p className="w-50 text-center">
                                    //     *Approved by{' '}
                                    //     {itemsRecords?.emp_firstname || ''}{' '}
                                    //     {itemsRecords?.emp_lastname || ''}
                                    // </p>

                                    <div className="m-2 font-weight-bold invoiceSubTitle">
                                        *Approved by{' '}
                                        {itemsRecords?.emp_firstname || ''}{' '}
                                        {itemsRecords?.emp_lastname || ''}
                                    </div>
                                ) : null}

                                <div className="formFields w-75 w-sm-100 mt-4">
                                    <label>Staff Notes :</label>
                                    <CustomTextArea
                                        disabled={true}
                                        type="text"
                                        placeholder=""
                                        value={itemsRecords?.admin_comments}
                                    />
                                </div>

                                <div className="formFields w-75 w-sm-100">
                                    <label>Edit Item ID :</label>
                                    <CustomInput
                                        type="text"
                                        name={`item_id`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleChange}
                                        value={formik.values.item_id}
                                        onFocus={() => setInputFocus(true)}
                                        placeholder="Enter Item ID"
                                        disabled={!isEditable}
                                        endAdornment={
                                            <>
                                                <Tooltip
                                                    title='On submission, automatically adds "_1" at the end. if "_1" already exists, it increments (e.g., "_1" becomes "_2")'
                                                    placement="top"
                                                    open={
                                                        isMobile
                                                            ? openToolTip
                                                            : undefined
                                                    }
                                                >
                                                    <span
                                                        className="material-icons closeBtn"
                                                        onClick={
                                                            isMobile
                                                                ? handleToolOpen
                                                                : undefined
                                                        }
                                                    >
                                                        info
                                                    </span>
                                                </Tooltip>
                                                <Tooltip
                                                    title={
                                                        isEditable
                                                            ? 'Disable editing'
                                                            : 'Enable editing'
                                                    }
                                                >
                                                    <span
                                                        className="material-icons"
                                                        style={{
                                                            cursor: 'pointer',
                                                            marginLeft: '8px',
                                                        }}
                                                        onClick={() =>
                                                            setIsEditable(
                                                                !isEditable
                                                            )
                                                        }
                                                    >
                                                        {isEditable
                                                            ? 'lock_open'
                                                            : 'edit'}
                                                    </span>
                                                </Tooltip>
                                            </>
                                        }
                                    />
                                </div>

                                <div className="formFields w-75 w-sm-100">
                                    <label>Title :</label>
                                    <CustomTextArea
                                        type="text"
                                        name={`title`}
                                        isDefault={true}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Enter Title"
                                        value={formik.values.title}
                                        onFocus={() => setInputFocus(true)}
                                    />
                                </div>

                                <div className="formFields w-75 w-sm-100">
                                    <label>Disclaimer :</label>
                                    <CustomInput
                                        type="text"
                                        name={`disclaimer`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        placeholder="Enter Disclaimer"
                                        value={formik.values.disclaimer}
                                        onFocus={() => setInputFocus(true)}
                                    />
                                </div>

                                <div className="formFields w-75 w-sm-100">
                                    <label>Description :</label>
                                    <CustomTextArea
                                        multiline
                                        isDefault={true}
                                        name={`desc_proc`}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={
                                            formik.values.desc_proc?.replace(
                                                /<[^>]+>/g,
                                                ''
                                            ) || ''
                                        }
                                        onFocus={() => setInputFocus(true)}
                                    />
                                </div>

                                {/* PHOTOS SECTION */}
                                <div className="formFields w-75 w-sm-100">
                                    <div className="d-flex justify-content-between w-100">
                                        <label className="mb-0">
                                            All photos :
                                        </label>
                                        <label className="mb-0">
                                            Check to add to listing
                                        </label>
                                    </div>
                                    <div className="imgCollageBox">
                                        <DndContext
                                            sensors={sensors}
                                            collisionDetection={closestCenter}
                                            onDragEnd={onDragEnd}
                                        >
                                            <SortableContext
                                                items={imagesOrder}
                                                strategy={
                                                    verticalListSortingStrategy
                                                }
                                            >
                                                {/* Drag-and-drop images in img little finger box */}
                                                <div className="imglittlefingerBox relistImages">
                                                    {imagesOrder.length > 0 ? (
                                                        imagesOrder.map(
                                                            (file, index) => (
                                                                <SortableImage
                                                                    key={file}
                                                                    id={file}
                                                                    file={file}
                                                                    index={
                                                                        index
                                                                    }
                                                                    checked={checkedImages.has(
                                                                        file
                                                                    )}
                                                                    onCheckChange={(
                                                                        isChecked
                                                                    ) => {
                                                                        handleCheckChange(
                                                                            file,
                                                                            isChecked
                                                                        )
                                                                    }}
                                                                />
                                                            )
                                                        )
                                                    ) : (
                                                        <img
                                                            src="/assets/images/noimage.png"
                                                            className="small"
                                                            alt="thumbnail"
                                                        />
                                                    )}
                                                </div>
                                            </SortableContext>
                                        </DndContext>

                                        {/* Image Zoom component */}
                                        <ImageZoom
                                            imageZoomModal={imageZoomModal}
                                            toggleImage={toggleImage}
                                            images={images}
                                            imageIndex={imageIndex}
                                            setImageZoomModal={
                                                setImageZoomModal
                                            }
                                        />
                                    </div>
                                </div>

                                <div className="formFields w-75 w-sm-100 formfields dropZoneField">
                                    <Button
                                        className="primaryButton uploadPhotoBtn"
                                        onClick={(e) =>
                                            setAddPhotos(!addPhotos)
                                        }
                                    >
                                        {addPhotos ? 'Hide' : 'Add Photos'}
                                    </Button>
                                    <>
                                        {addPhotos ? (
                                            <div className="row fileUploadRow">
                                                {mapData(fileUpload)}
                                            </div>
                                        ) : null}
                                    </>
                                </div>

                                <div className="formFields w-75 w-sm-100 mt-3">
                                    <label>New Location :</label>
                                    <CustomInput
                                        type="text"
                                        name={`bin_location`}
                                        onFocus={() => setInputFocus(true)}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.bin_location}
                                        placeholder="Enter Location in facility"
                                        endAdornment={
                                            <span
                                                className="material-symbols-outlined"
                                                onClick={() =>
                                                    handleScanInput('product')
                                                }
                                                style={{
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                barcode_scanner
                                            </span>
                                        }
                                    />
                                </div>
                                <div className="itesBtnGrp mt-2">
                                    <Button
                                        // onClick={formik.handleSubmit}
                                        onClick={() =>
                                            handleRelistType('relist')
                                        }
                                        className="PrimaryButton"
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>

                            <BarCodeScan
                                scanToggle={scanToggle}
                                changeScanDialogStatus={changeScanDialogStatus}
                                setDecodedBarcode={setDecodedBarcode}
                                // videoConstraints={videoConstraints}
                            />

                            {/* Bulk Move Popup */}
                            <Dialog
                                open={bulkOpen}
                                onClose={() => {
                                    handleCloseRelist('bulk')
                                }}
                                className="returnflowDialog proEditView"
                            >
                                <>
                                    <div className="d-flex justify-content-end">
                                        <Button
                                            className="material-symbols-outlined modalClosePerment editCancelModel"
                                            onClick={() => {
                                                handleCloseRelist('bulk')
                                            }}
                                        >
                                            <span className="material-icons">
                                                cancel
                                            </span>
                                        </Button>
                                    </div>
                                    <DialogContent style={{ padding: 15 }}>
                                        <div className="text-left returnInfoListGet proEditView">
                                            <div className="formFields  w-sm-100">
                                                <label>New Location :</label>
                                                <CustomInput
                                                    type="text"
                                                    name={`bin_location`}
                                                    onFocus={() =>
                                                        setInputFocus(true)
                                                    }
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    value={
                                                        formik.values
                                                            .bin_location
                                                    }
                                                    placeholder="Enter Location in facility"
                                                    endAdornment={
                                                        <span
                                                            className="material-symbols-outlined"
                                                            onClick={() =>
                                                                handleScanInput(
                                                                    'product'
                                                                )
                                                            }
                                                            style={{
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            barcode_scanner
                                                        </span>
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="actionBtnGrops text-center mt-1">
                                            <Button
                                                // type="submit"
                                                onClick={async () => {
                                                    const isValid =
                                                        await validateForm()
                                                    if (isValid) {
                                                        formik.handleSubmit()
                                                    }
                                                }}
                                                className="primaryButton"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </DialogContent>
                                </>
                            </Dialog>

                            {/* Discard Popup */}
                            <Dialog
                                open={discardOpen}
                                onClose={() => {
                                    handleCloseRelist('discard')
                                }}
                                className="returnflowDialog proEditView"
                            >
                                <>
                                    <div className="d-flex justify-content-end">
                                        <Button
                                            className="material-symbols-outlined modalClosePerment editCancelModel"
                                            onClick={() => {
                                                handleCloseRelist('discard')
                                            }}
                                        >
                                            <span className="material-icons">
                                                cancel
                                            </span>
                                        </Button>
                                    </div>
                                    <DialogContent style={{ padding: 15 }}>
                                        <div className="formFields">
                                            <p>
                                                The item will be moved to unpaid
                                                inventory and marked as
                                                discarded.
                                            </p>
                                        </div>
                                        <div className="actionBtnGrops text-center mt-1">
                                            <Button
                                                // type="submit"
                                                onClick={async () => {
                                                    const isValid =
                                                        await validateForm()
                                                    if (isValid) {
                                                        formik.handleSubmit()
                                                    }
                                                }}
                                                className="primaryButton"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </DialogContent>
                                </>
                            </Dialog>

                            {/* Confirm Relist Popup */}
                            <Dialog
                                open={relistOpen}
                                onClose={() => {
                                    handleCloseRelist('relist')
                                }}
                                className="returnflowDialog proEditView"
                            >
                                <>
                                    <div className="d-flex justify-content-end">
                                        <Button
                                            className="material-symbols-outlined modalClosePerment editCancelModel"
                                            onClick={() => {
                                                handleCloseRelist('relist')
                                            }}
                                        >
                                            <span className="material-icons">
                                                cancel
                                            </span>
                                        </Button>
                                    </div>
                                    <DialogContent style={{ padding: 15 }}>
                                        <div className="formFields">
                                            <p>
                                                Are you sure that this item is
                                                ready to be relisted?
                                            </p>
                                        </div>
                                        <div className="actionBtnGrops text-center mt-1">
                                            <Button
                                                // type="submit"
                                                className="primaryButton"
                                                onClick={async () => {
                                                    const isValid =
                                                        await validateForm()
                                                    if (isValid) {
                                                        formik.handleSubmit()
                                                    }
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </DialogContent>
                                </>
                            </Dialog>
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}
export default StepTwo
